/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApAdBnrGetResponseApiFrom } from '../models/ap-ad-bnr-get-response-api-from';
import { ApAdListResponseApiFrom } from '../models/ap-ad-list-response-api-from';
import { ApDataGetResponseApiFrom } from '../models/ap-data-get-response-api-from';
import { apiV3ServiceApAdBnrGetGet } from '../fn/banner/api-v-3-service-ap-ad-bnr-get-get';
import { ApiV3ServiceApAdBnrGetGet$Params } from '../fn/banner/api-v-3-service-ap-ad-bnr-get-get';
import { apiV3ServiceApAdBnrGetGet$Plain } from '../fn/banner/api-v-3-service-ap-ad-bnr-get-get-plain';
import { ApiV3ServiceApAdBnrGetGet$Plain$Params } from '../fn/banner/api-v-3-service-ap-ad-bnr-get-get-plain';
import { apiV3ServiceApAdListGet } from '../fn/banner/api-v-3-service-ap-ad-list-get';
import { ApiV3ServiceApAdListGet$Params } from '../fn/banner/api-v-3-service-ap-ad-list-get';
import { apiV3ServiceApAdListGet$Plain } from '../fn/banner/api-v-3-service-ap-ad-list-get-plain';
import { ApiV3ServiceApAdListGet$Plain$Params } from '../fn/banner/api-v-3-service-ap-ad-list-get-plain';
import { apiV3ServiceApDataGetGet } from '../fn/banner/api-v-3-service-ap-data-get-get';
import { ApiV3ServiceApDataGetGet$Params } from '../fn/banner/api-v-3-service-ap-data-get-get';
import { apiV3ServiceApDataGetGet$Plain } from '../fn/banner/api-v-3-service-ap-data-get-get-plain';
import { ApiV3ServiceApDataGetGet$Plain$Params } from '../fn/banner/api-v-3-service-ap-data-get-get-plain';
import { apiV3ServiceApVersionGetGet } from '../fn/banner/api-v-3-service-ap-version-get-get';
import { ApiV3ServiceApVersionGetGet$Params } from '../fn/banner/api-v-3-service-ap-version-get-get';
import { apiV3ServiceApVersionGetGet$Plain } from '../fn/banner/api-v-3-service-ap-version-get-get-plain';
import { ApiV3ServiceApVersionGetGet$Plain$Params } from '../fn/banner/api-v-3-service-ap-version-get-get-plain';
import { ApVersionGetResponseApiFrom } from '../models/ap-version-get-response-api-from';

@Injectable({ providedIn: 'root' })
export class ApiFromBannerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceApAdBnrGetGet()` */
  static readonly ApiV3ServiceApAdBnrGetGetPath = '/api/v3/service/ApAdBnrGet';

  /**
   * Getting the banner file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApAdBnrGetGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdBnrGetGet$Plain$Response(params?: ApiV3ServiceApAdBnrGetGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApAdBnrGetResponseApiFrom>> {
    return apiV3ServiceApAdBnrGetGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the banner file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApAdBnrGetGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdBnrGetGet$Plain(params?: ApiV3ServiceApAdBnrGetGet$Plain$Params, context?: HttpContext): Observable<ApAdBnrGetResponseApiFrom> {
    return this.apiV3ServiceApAdBnrGetGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApAdBnrGetResponseApiFrom>): ApAdBnrGetResponseApiFrom => r.body)
    );
  }

  /**
   * Getting the banner file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApAdBnrGetGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdBnrGetGet$Response(params?: ApiV3ServiceApAdBnrGetGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ApAdBnrGetResponseApiFrom>> {
    return apiV3ServiceApAdBnrGetGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the banner file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApAdBnrGetGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdBnrGetGet(params?: ApiV3ServiceApAdBnrGetGet$Params, context?: HttpContext): Observable<ApAdBnrGetResponseApiFrom> {
    return this.apiV3ServiceApAdBnrGetGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApAdBnrGetResponseApiFrom>): ApAdBnrGetResponseApiFrom => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceApVersionGetGet()` */
  static readonly ApiV3ServiceApVersionGetGetPath = '/api/v3/service/ApVersionGet';

  /**
   * Getting the ID of the current version of the design.
   *
   * Getting the identifier of the current version of the design (animated ticket and ticket pictures)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApVersionGetGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApVersionGetGet$Plain$Response(params?: ApiV3ServiceApVersionGetGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApVersionGetResponseApiFrom>> {
    return apiV3ServiceApVersionGetGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the ID of the current version of the design.
   *
   * Getting the identifier of the current version of the design (animated ticket and ticket pictures)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApVersionGetGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApVersionGetGet$Plain(params?: ApiV3ServiceApVersionGetGet$Plain$Params, context?: HttpContext): Observable<ApVersionGetResponseApiFrom> {
    return this.apiV3ServiceApVersionGetGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApVersionGetResponseApiFrom>): ApVersionGetResponseApiFrom => r.body)
    );
  }

  /**
   * Getting the ID of the current version of the design.
   *
   * Getting the identifier of the current version of the design (animated ticket and ticket pictures)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApVersionGetGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApVersionGetGet$Response(params?: ApiV3ServiceApVersionGetGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ApVersionGetResponseApiFrom>> {
    return apiV3ServiceApVersionGetGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the ID of the current version of the design.
   *
   * Getting the identifier of the current version of the design (animated ticket and ticket pictures)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApVersionGetGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApVersionGetGet(params?: ApiV3ServiceApVersionGetGet$Params, context?: HttpContext): Observable<ApVersionGetResponseApiFrom> {
    return this.apiV3ServiceApVersionGetGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApVersionGetResponseApiFrom>): ApVersionGetResponseApiFrom => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceApDataGetGet()` */
  static readonly ApiV3ServiceApDataGetGetPath = '/api/v3/service/ApDataGet';

  /**
   * Retrieving Design Element Data.
   *
   * Getting design element data (fare pictures and animated ticket)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApDataGetGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApDataGetGet$Plain$Response(params?: ApiV3ServiceApDataGetGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApDataGetResponseApiFrom>>> {
    return apiV3ServiceApDataGetGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieving Design Element Data.
   *
   * Getting design element data (fare pictures and animated ticket)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApDataGetGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApDataGetGet$Plain(params?: ApiV3ServiceApDataGetGet$Plain$Params, context?: HttpContext): Observable<Array<ApDataGetResponseApiFrom>> {
    return this.apiV3ServiceApDataGetGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApDataGetResponseApiFrom>>): Array<ApDataGetResponseApiFrom> => r.body)
    );
  }

  /**
   * Retrieving Design Element Data.
   *
   * Getting design element data (fare pictures and animated ticket)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApDataGetGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApDataGetGet$Response(params?: ApiV3ServiceApDataGetGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApDataGetResponseApiFrom>>> {
    return apiV3ServiceApDataGetGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieving Design Element Data.
   *
   * Getting design element data (fare pictures and animated ticket)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApDataGetGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApDataGetGet(params?: ApiV3ServiceApDataGetGet$Params, context?: HttpContext): Observable<Array<ApDataGetResponseApiFrom>> {
    return this.apiV3ServiceApDataGetGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApDataGetResponseApiFrom>>): Array<ApDataGetResponseApiFrom> => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceApAdListGet()` */
  static readonly ApiV3ServiceApAdListGetPath = '/api/v3/service/ApAdList';

  /**
   * Get banners list.
   *
   * Get active banners list.
   * Empty list means no banners to display.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApAdListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdListGet$Plain$Response(params?: ApiV3ServiceApAdListGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApAdListResponseApiFrom>>> {
    return apiV3ServiceApAdListGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get banners list.
   *
   * Get active banners list.
   * Empty list means no banners to display.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApAdListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdListGet$Plain(params?: ApiV3ServiceApAdListGet$Plain$Params, context?: HttpContext): Observable<Array<ApAdListResponseApiFrom>> {
    return this.apiV3ServiceApAdListGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApAdListResponseApiFrom>>): Array<ApAdListResponseApiFrom> => r.body)
    );
  }

  /**
   * Get banners list.
   *
   * Get active banners list.
   * Empty list means no banners to display.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceApAdListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdListGet$Response(params?: ApiV3ServiceApAdListGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApAdListResponseApiFrom>>> {
    return apiV3ServiceApAdListGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get banners list.
   *
   * Get active banners list.
   * Empty list means no banners to display.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceApAdListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceApAdListGet(params?: ApiV3ServiceApAdListGet$Params, context?: HttpContext): Observable<Array<ApAdListResponseApiFrom>> {
    return this.apiV3ServiceApAdListGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApAdListResponseApiFrom>>): Array<ApAdListResponseApiFrom> => r.body)
    );
  }

}
